export default __webpack_public_path__ + "static/media/consorcioLogo.90eeb059.svg";